import { useSelector } from 'react-redux'
import FormPersonalDetailDetail from './form-detail'
import CheckUserAdmin from '../../../../../helper/check-user-admin'

function PersonalDetails() {
  const { profile } = useSelector((state) => state.profileReducer)

  const roleId = useSelector((state) => state.roleReducer.role)
  const profileId = useSelector((state) => state.loginReducer.profile)
  const roles = CheckUserAdmin(profileId.roles, roleId)

  return (
    profile?.orgId &&
    profile?.code && (
      <>
        <FormPersonalDetailDetail
          orgId={profile?.orgId}
          code={profile?.code}
          btn_edit={roles?.status_id === 1}
        />
      </>
    )
  )
}

export default PersonalDetails
